<div class="cpcontent">
    <h2> Scenarios</h2>
    <div  *ngIf="hasRole('Developer')" style="display:inline-block;max-width:300px" >
        <sa-select class="inlineform" [(Id)]="key" [title]="'Select an organization'" [options]="scenariogroups" [IdField]="'key'"  [NameField]="'orgname'"></sa-select><br>
    </div>
    <button *ngIf="hasRole('Developer')"  style="display:inline-block;vertical-align: top;margin-left:20px;margin-top:30px" class="btn btn-primary" (click)="filterByOrg(key)">Filter</button>
    <button *ngIf="hasRole('Developer')"  style="display:inline-block;vertical-align: top;margin-left:20px;margin-top:30px" class="btn btn-primary" (click)="filterByOrg(0)">Clear</button>
    <button  style="display:inline-block;vertical-align: top;margin-left:20px;margin-top:30px" class="btn btn-primary" (click)="add()">New Scenario</button>  
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Id
                    <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortGeneric(scenariosdisplay,'id',sortArray)"></i>
                </th>
                <th>Name
                    <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortGeneric(scenariosdisplay,'name',sortArray)"></i>
                </th>
                <th>
                    Organization 
                    <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortGeneric(scenariosdisplay,'orgname',sortArray)"></i>
                </th>
                <th>
                    GPS / Beacon
                    <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortGeneric(scenariosdisplay,'hasGPS',sortArray)"></i>
                </th>
                <!-- <th>Creator</th> -->
                <th>Creation Date
                    <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortGeneric(scenariosdisplay,'creationDate',sortArray)"></i>
                </th>
                <th>Delete</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let scen of scenariosdisplay">
                <td>{{scen.id}}</td>
                <td class="link" (click)="selectScenario(scen)">{{scen.name}}</td>
                <td>{{lookup(scen.organizationId,organizations)}}</td>
                <td>
                    <span *ngIf="scen.hasGPS">GPS</span>
                    <span *ngIf="!scen.hasGPS">Beacon</span>
                </td>
                <!-- <td>
                    {{scen.creator}}
                </td> -->
                <td>{{scen.creationDate | date: 'shortDate'}}</td>
                <td><button class="btn btn-warning btn-sm" (click)="delete(scen)">Delete</button></td>
            </tr>
        </tbody>
    </table>


</div>

<!-- Modal ----------------------------------------------->
<div *ngIf="showScenWizard" #testmodal class="cpmodal">
    <div class="cpmodal-content">
        <div class="cpmodal-header">
            Create New Scenario Wizard
        </div>
        <sa-input-text class="inlineform" [(text)]="newScenario.name" [title]="'Scenario Name'" [required]="'text'"></sa-input-text>
        Will you use GPS or Bluetooth based simluators in this scenario?
        <sa-input-radio [(selectedType)]="newScenario.selectedType" [title]="'Type'" [types]="['GPS','Beacon']"></sa-input-radio>
        <br>

        <button class="btn btn-primary" (click)="createNewScenario()">Save</button>
        <button class="btn btn-primary" style="float:right" (click)="showScenWizard = false">Cancel</button>
        <br>{{newScenario | json}}
    </div>
</div>
